import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: Home,
    children: [
      {
        path: '/',
        name: 'cover'
      },
      {
        name: 'about',
        path: 'about',
        meta: {
          chapter: 1,
          title: 'about-route-title'
        },
        children: [
          {
            name: 'who',
            path: 'who',
            children: [
              {
                name: 'who-stakeholders',
                path: 'stakeholders',
                meta: {
                  back: true
                }
              }
            ]
          },
          {
            name: 'why',
            path: 'why'
          },
          {
            name: 'about-quote',
            path: 'quote'
          }
        ]
      },
      {
        name: 'value',
        path: 'value',
        meta: {
          chapter: 2,
          title: 'value-route-title'
        },
        children: [
          {
            name: 'value-quote-a',
            path: 'quote-a'
          },
          {
            name: 'value-cover',
            path: 'cover',
            children: [
              {
                name: 'cover-details',
                path: 'details',
                meta: {
                  back: true
                }
              },
              {
                name: 'cover-history50',
                path: 'history50',
                meta: {
                  back: true
                }
              },
              {
                name: 'cover-history10',
                path: 'history10',
                meta: {
                  back: true
                }
              }
            ]
          },
          {
            name: 'projects',
            path: 'projects',
            children: [
              {
                name: 'projects-explanation',
                path: 'explanation',
                meta: {
                  back: true
                }
              },
              {
                name: 'projects-details',
                path: 'details',
                meta: {
                  subtitle: 'value-projects-title',
                  back: true,
                  inverted: true
                },
                children: [
                  {
                    name: 'projects-project-id',
                    path: ':id',
                    meta: {
                      back: true,
                      inverted: false
                    }
                  }
                ]
              }
            ]
          },
          {
            name: 'covid',
            path: 'covid',
            children: [
              {
                name: 'covid-explanation',
                path: 'explanation',
                meta: {
                  back: true
                }
              },
              {
                name: 'covid-details',
                path: 'details',
                meta: {
                  subtitle: 'value-covid-title',
                  back: true,
                  inverted: true
                },
                children: [
                  {
                    name: 'covid-project-id',
                    path: ':id',
                    meta: {
                      back: true,
                      inverted: false
                    }
                  }
                ]
              }
            ]
          },
          {
            name: 'research',
            path: 'research',
            children: [
              {
                name: 'research-explanation',
                path: 'explanation',
                meta: {
                  back: true
                }
              },
              {
                name: 'research-details',
                path: 'details',
                meta: {
                  subtitle: 'value-research-title',
                  back: true,
                  inverted: true
                },
                children: [
                  {
                    name: 'research-project-id',
                    path: ':id',
                    meta: {
                      back: true,
                      inverted: false
                    }
                  }
                ]
              }
            ]
          },
          {
            name: 'solidarity',
            path: 'solidarity',
            children: [
              {
                name: 'solidarity-explanation',
                path: 'explanation',
                meta: {
                  back: true
                }
              },
              {
                name: 'solidarity-details',
                path: 'details',
                meta: {
                  subtitle: 'value-solidarity-title',
                  back: true,
                  inverted: true
                },
                children: [
                  {
                    name: 'solidarity-project-id',
                    path: ':id',
                    meta: {
                      back: true,
                      inverted: false
                    }
                  }
                ]
              }
            ]
          },
          {
            name: 'value-quote-b',
            path: 'quote-b'
          }
        ]
      },
      {
        name: 'credits',
        path: 'credits',
        meta: {
          title: 'credits-route-title',
          chapter: 3,
          inverted: true
        }
      }
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router;
